import { call, put, select, takeLatest } from "redux-saga/effects";
import { showAlert } from "../../alertSlice";
import { saveWorkflowApi } from "../../../api/apiLists/workflow";
import {
  saveWorkflowFailure,
  saveWorkflowRequest,
  saveWorkflowStart,
  saveWorkflowSuccess,
  uploadWorkflowMediaRequest,
  workflowMediaUploadFailure,
  workflowMediaUploadStart,
  workflowMediaUploadSuccess
} from "../../slices/workflow";
import { callWorkflowApi, requireWhatsAppModuleAccess } from "./workflowSagaHelper";
import { uploadWorkflowMediaToS3 } from "./workflowMediaHelper";

function* handleSaveWorkflow(action) {
  if (!(yield call(requireWhatsAppModuleAccess))) return;

  const body = action.payload || {};
  const silent = body.meta?.silent === true || action.meta?.silent === true;
  const req = {
    operation: body.operation || "SAVE_WORKFLOW",
    payload: body.payload || {},
  };

  try {
    yield put(saveWorkflowStart());

    const res = yield callWorkflowApi(saveWorkflowApi, req);

    if (res?.status) {
      const savedPayload = req.payload || {};
      yield put(saveWorkflowSuccess({
        ...(res?.data || {}),
        workflowId:
          res?.data?.workflowId
          || res?.data?.workflow?.workflowId
          || savedPayload.workflowId,
        draftVersion:
          res?.data?.draftVersion
          || res?.data?.workflow?.draftVersion
          || res?.data?.version
      }));
      if (!silent) {
        yield put(showAlert({
          message: res?.data?.message || "Workflow saved successfully.",
          type: "success"
        }));
      }
      return;
    }

    const errMsg = res?.errMsg || "Failed to save workflow";
    yield put(saveWorkflowFailure(errMsg));
    yield put(showAlert({ message: errMsg, type: "error" }));
  } catch (error) {
    const errMsg = error.message || "Failed to save workflow";
    yield put(saveWorkflowFailure(errMsg));
    yield put(showAlert({ message: errMsg, type: "error" }));
  }
}

function* handleUploadWorkflowMedia(action) {
  if (!(yield call(requireWhatsAppModuleAccess))) return;

  const { requestId, file } = action.payload || {};

  if (!requestId || !file) {
    yield put(workflowMediaUploadFailure({ requestId, error: "Missing file for upload" }));
    yield put(showAlert({ message: "Missing file for upload", type: "error" }));
    return;
  }

  try {
    yield put(workflowMediaUploadStart({ requestId, nodeId: action.payload?.nodeId }));

    const companyId = yield select(
      (state) => state.auth?.user?.companyId || state.auth?.companyId || state.companyInfo?.info?.companyId
    );

    const mediaUpload = yield call(uploadWorkflowMediaToS3, { file, companyId });

    if (!mediaUpload.ok) {
      yield put(workflowMediaUploadFailure({ requestId, error: mediaUpload.errMsg }));
      yield put(showAlert({ message: mediaUpload.errMsg, type: "error" }));
      return;
    }

    yield put(workflowMediaUploadSuccess({
      requestId,
      nodeId: action.payload?.nodeId || null,
      url: mediaUpload.url,
      filename: mediaUpload.filename,
    }));
  } catch (error) {
    const errMsg = error.message || "Failed to upload media";
    yield put(workflowMediaUploadFailure({ requestId, error: errMsg }));
    yield put(showAlert({ message: errMsg, type: "error" }));
  }
}

export default function* workflowSaveSaga() {
  yield takeLatest(saveWorkflowRequest.type, handleSaveWorkflow);
  yield takeLatest(uploadWorkflowMediaRequest.type, handleUploadWorkflowMedia);
}
